import {useEffect} from "react";
import {DEFAULT_LOOK, applyLook, savedLook} from "../shared/utils/look";
import {DEFAULT_THEME, applyTheme, savedTheme} from "../shared/utils/theme";

/**
 * For the public pages: wear the provider's color while the page is open, so
 * the customer sees the order or the showcase in the provider's color, and
 * always in the default look (the other looks are an experiment for the
 * provider's own screens). Nothing is saved: the visitor's own choices, if
 * any, come back when the page closes. `theme` is `undefined` while the page
 * is loading (the color doesn't change yet), `null` when the provider chose
 * none (the default).
 *
 * @param {string|null|undefined} theme
 */
export const useProviderTheme = (theme) => {
    useEffect(() => {
        applyLook(DEFAULT_LOOK);
        return () => applyLook(savedLook());
    }, []);

    useEffect(() => {
        if (theme === undefined) return undefined;
        applyTheme(theme ?? DEFAULT_THEME);
        return () => applyTheme(savedTheme());
    }, [theme]);
};
